"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var de_messages = _interopRequireWildcard(require("./locales/de-DE/contextual_help.json"));
var en_messages = _interopRequireWildcard(require("./locales/en-US/contextual_help.json"));
var es_messages = _interopRequireWildcard(require("./locales/es-ES/contextual_help.json"));
var fr_messages = _interopRequireWildcard(require("./locales/fr-FR/contextual_help.json"));
var it_messages = _interopRequireWildcard(require("./locales/it-IT/contextual_help.json"));
var ja_messages = _interopRequireWildcard(require("./locales/ja-JP/contextual_help.json"));
var ko_messages = _interopRequireWildcard(require("./locales/ko-KR/contextual_help.json"));
var pt_messages = _interopRequireWildcard(require("./locales/pt-BR/contextual_help.json"));
var ru_messages = _interopRequireWildcard(require("./locales/ru-RU/contextual_help.json"));
var zh_messages = _interopRequireWildcard(require("./locales/zh-CN/contextual_help.json"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// (C) Copyright 2021-2023 Hewlett Packard Enterprise Development LP

// import detector from 'i18next-browser-languagedetector'

var i18n = _i18next["default"].createInstance();
i18n
// .use(detector)
.init({
  // lng: 'ja-JP',
  fallbackLng: 'en-US',
  supportedLngs: ['en-US', 'de-DE', 'es-ES', 'fr-FR', 'it-IT', 'ja-JP', 'ko-KR', 'pt-BR', 'ru-RU', 'zh-CN'],
  ns: [
  /**
   * Only 'contextual_help' ns is used for all help locales
   */

  // 'apps',
  // 'auditlogs',
  // 'authn',
  // 'authz',
  // 'cdsReporting',
  // 'common',
  'contextual_help'
  // 'header',
  // 'device',
  // 'licensing',
  // 'local-gateway',
  // 'location',
  // 'manage',
  // 'reporting',
  // 'tutorial',
  ],
  resources: {
    'de-DE': {
      contextual_help: de_messages["default"]
    },
    'en-US': {
      contextual_help: en_messages["default"]
    },
    'es-ES': {
      contextual_help: es_messages["default"]
    },
    'fr-FR': {
      contextual_help: fr_messages["default"]
    },
    'it-IT': {
      contextual_help: it_messages["default"]
    },
    'ja-JP': {
      contextual_help: ja_messages["default"]
    },
    'ko-KR': {
      contextual_help: ko_messages["default"]
    },
    'pt-BR': {
      contextual_help: pt_messages["default"]
    },
    'ru-RU': {
      contextual_help: ru_messages["default"]
    },
    'zh-CN': {
      contextual_help: zh_messages["default"]
    }
  },
  load: 'currentOnly'
  // debug: import.meta.env.DEV,
});
var _default = exports["default"] = i18n;